"use client";

import {useContext} from "react";
import {useTranslation} from "react-i18next";
import {ArtifactPanelProvider} from "@/contexts/chat/ArtifactPanelContext";
import {useGailDock} from "@/contexts/chat/GailDockContext";
import {ScriptProposalSideConversationContext} from "@/contexts/chat/ScriptProposalReviewContext";
import {useOrg} from "@/hooks/useOrg";
import ChatViewContainer from "./ChatViewContainer";

/** The script editor stays on the page. The conversation sits in the dock, or beside the editor when the dock is unavailable. */
export default function ScriptProposalReviewSlot({children}: {children: React.ReactNode}) {
   const conversationId = useContext(ScriptProposalSideConversationContext);
   const {isDockAvailable} = useGailDock();
   const {org} = useOrg();
   const {t} = useTranslation("ask");
   if (!conversationId || isDockAvailable) return children;
   return <div className="flex min-h-[calc(100dvh-4rem)] min-w-0 flex-col md:min-h-dvh md:flex-row">
      <div className="min-h-0 min-w-0 flex-1">{children}</div>
      <ArtifactPanelProvider>
         <aside aria-label={t("toolApproval.openConversation")} className="h-[35dvh] shrink-0 border-t border-300 bg-panel md:h-auto md:w-[380px] md:border-l md:border-t-0 xl:w-[420px]">
            <ChatViewContainer orgId={org?.id} conversationId={conversationId} fillContainer />
         </aside>
      </ArtifactPanelProvider>
   </div>;
}
